define('Components/NewsWidget/js/models/NewsWidgetInstanceModel',['underscore','app','WidgetInstanceModel','models/NewsCollection','UrlFactory'],function(_,app,WidgetInstanceModel,NewsCollection,UrlFactory){
    return WidgetInstanceModel.extend({
        name:'NewsWidgetModel',
        getMaxPerPage:function(){
            return Math.max(Math.min(parseInt(this.p('max_per_page')), 4), 2);
        },
        getInterval:function(){
            return this.p('slideInterval');
        },
        getNbMax:function(){
            return this.p('nbItems');
        },
        getNewsNbBySlide:function(){
            return app.isDesktop() ? 3 : 1;
        },
        getNbSlide:function(){
            return Math.ceil(this.getNbNews()/this.getNewsNbBySlide());
        },
        openSlide:function(n){
            return n % this.getMaxPerPage() == 0;
        },
        getNbNews: function(){
            return this.getNews().size();
        },
        closeSlide:function(n){
            return ((n+1) % this.getMaxPerPage() == 0
                    || (n == this.getNews().size()-1));
        },
        getNbMaxNews:function(){
            if (app.isMobile()) {
                if (this.getNbNews() < this.getNbMax()) {
                    return this.getNbNews();
                } else {
                    return this.getNbMax();
                }
            } else {
                if (Math.ceil(this.getNbNews() / this.getMaxPerPage()) < this.getNbSlide()) {
                    return Math.ceil(this.getNbNews() / this.getMaxPerPage());
                } else {
                    return this.getNbSlide();
                }
            }
        },
        getPageUrl:function(){
            return UrlFactory.getUrl('newsHome');
        },
        getNews:function(){
            var model = this,
                newsIds,

                newsCollection = model.newsCollection;
            if(newsCollection){
                // use instanced collection
                return newsCollection;
            }else{
                var news_flag_include = model.p('newstaginclude'),
                    news_flag_exclude = model.p('newstagexclude'),
                    newsIds = [];
                _(news_flag_include).each(function(id_news_flag){
                    var newsFlag = app.getNewsFlag(id_news_flag);
                    if(newsFlag) newsIds = _.union(newsIds,newsFlag.get('news'));
                });
                _(news_flag_exclude).each(function(id_news_flag){
                    var newsFlag = app.getNewsFlag(id_news_flag);
                    if(newsFlag) newsIds = _.difference(newsIds,newsFlag.get('news'));
                });

                newsCollection = new NewsCollection();
                _(newsIds).each(function(id_news){
                    newsCollection.add(app.getNews(id_news));
                });
                model.newsCollection = newsCollection;
            }
            return newsCollection;

        }
    })
});
